import { makeStyles } from '@material-ui/core/styles';
import { Palette } from '@jda/lui-common-component-library';
const useStyles = makeStyles(theme => ({
  root: {
    margin: '6%'
  },
  icon: {
    color: theme.palette.background.paper,
    cursor: 'pointer'
  },
  header: {
    display: 'flex',
    backgroundColor: '#fff',
    marginBottom: '2%',
    padding: '10px 20px',
    borderRadius: '5px',
    '& button': {
      margin: '0 3px'
    }
  },
  content: {
    padding: '20px 0'
  },
  select: {
    margin: '0px auto',
    minWidth: '90%'
  },
  typographyLabel: {
    fontSize: theme.spacing(2),
    fontWeight: 'bold',
    color: theme.palette.text.primary
  },
  goBack: {
    color: theme.palette.background.paper,
    fontSize: '26px'
  },
  label: {
    margin: '10px',
    fontWeight: 'bold'
  },
  fieldList: {
    background: '#ececec',
    margin: '10px 0px',
    padding: '3px',
    borderRight: '5px solid #fff'
  },
  form: {
    padding: '20px 6px',
    marginTop: '20px',
    borderBottom: '1px solid #ececec',
    background: '#ececec',
    textAlign: 'center'
  },
  stepList: {
    border: '1px solid #c4bdbd',
    borderRadius: '5px',
    padding: '10px 20px',
    // textAlign: 'center',
    cursor: 'pointer',
    backgroundColor: '#e6e1e138',
    margin: '10px 0'
  },
  table: {
    backgroundColor: theme.palette.background.paper
  },
  tableRow: {
    '&$selected, &$selected:hover': {
      backgroundColor: `${Palette.colors.byBlue['50']} !important`
    },
    '&:nth-child(even):not(.materialTableRowRef)': {
      backgroundColor: theme.palette.background.paper,
      '&:hover': {
        backgroundColor: Palette.colors.grey['100']
      }
    },
    '&:nth-child(odd):not(.materialTableRowRef)': {
      '&:hover': {
        backgroundColor: Palette.colors.grey['100']
      }
    }
  },
  tableCell: {
    padding: '1vh',
    paddingLeft: theme.spacing(1),
    height: theme.spacing(5.25)
  },
  tableBody: {
    cursor: 'pointer'
  },
  timeline: {
    position: 'relative',
    '&:after': {
      content: "''",
      display: 'block',
      position: 'absolute',
      top: 0,
      bottom: 0,
      left: '6.8%;',
      width: '3px',
      backgroundColor: '#ececec',
      marginTop: '2px'
    },
    '& .disabled': {
      color: '#cfcaca'
    }
  },
  timelinePost: {
    margin: '0 auto',
    marginTop: '15px',
    '& .active': {
      background: '#10f046',
      color: '#fff'
    }
  },
  requestContent: {
    cursor: 'pointer',
    fontWeight: 'bold',
    fontSize: '15px',
    padding: '5px 10px'
  },
  timelineChip: {
    color: '#6c6b6b',
    fontWeight: 500,
    fontSize: '25px',
    borderRadius: '14px',
    cursor: 'pointer'
  },
  formFields: {
    background: ' #fff',
    borderRight: '10px solid #f4f4f4',
    margin: '15px 0'
  },
  executeStep: {
    background: ' #f4f4f4',
    minHeight: '50vh'
  },
  execution: {
    padding: '10px 15px',
    fontSize: '14px',
    fontWeight: 'bold'
  },
  stepResult: {
    margin: '10px 0',
    padding: '10px'
  },
  grid: {
    width: '100%',
    borderBottom: '1px solid #EBEBEB'
  },
  gridSelection: {
    border: '1px solid',
    borderColor: 'white',
    width: '100%',
    maxHeight: '51vh',
    borderRadius: theme.spacing(0.5)
  },
  headers: {
    color: theme.palette.text.secondary
  },
  textField: {
    width: '80%'
  },
  container: {
    marginBottom: theme.spacing(2)
  },
  mainGrid: {
    margin: theme.spacing(0.2),
    marginBottom: theme.spacing(0.2),
    marginRight: theme.spacing(0.2),
    backgroundColor: theme.palette.background.paper,
    width: 'auto',
    padding: theme.spacing(2),
    paddingTop: theme.spacing(1),
    borderRadius: theme.spacing(0.5)
  },
  wrapper: {
    backgroundColor: Palette.colors.cornflower['50']
  },
  buttonMargin: {
    fontFamily: 'Roboto',
    fontStyle: 'normal',
    fontWeight: 500,
    fontSize: '14px',
    alignItems: 'center',
    marginLeft: theme.spacing(2)
  },
  circle: {
    display: 'flex',
    width: '30px',
    height: '30px',
    backgroundColor: '#e6e1e138',
    borderRadius: '50%'
  }
}));

export default useStyles;
